// 店铺
import * as type from "../mutation-types"
const state = {
  data:window.localStorage.getItem("shop") || ""
}

const getters = {
  getShop:state=>state.data
}

const mutations = {
  [type.USER_OUT_LOGIN](state){
    state.data = null
  }
}

const actions = {
  onUse(response){
    window.localStorage.setItem("shop",response)
  },
  outLogin({commit}){
    commit(type.USER_OUT_LOGIN)
    window.localStorage.removeItem("shop")
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}